import { createContext, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useGetCashBalanceWithFallback } from '../hooks/useGetCashBalanceWithFallback';
import { useLocation } from 'react-router-dom';

const CashBalanceContext = createContext(null);

export const CashBalanceProvider = ({ children }) => {
  const [balance, setBalance] = useState(null);
  const { user } = useSelector(state => state.auth);
  const location = useLocation();

  const { data: balanceData, loading, error, refetch } = useGetCashBalanceWithFallback();

  useEffect(() => {
    if (user) {
      refetch();
    }
  }, [user, refetch, location.pathname]);

  useEffect(() => {
    if (balanceData?.getCashBalancePortfolio || balanceData?.getCashBalanceBackup) {
      setBalance(balanceData.getCashBalancePortfolio || balanceData.getCashBalanceBackup);
    }
  }, [balanceData]);

  return (
    <CashBalanceContext.Provider value={{ balance, loading, error, refetch }}>
      {children}
    </CashBalanceContext.Provider>
  );
};

export const useCashBalance = () => {
  const context = useContext(CashBalanceContext);
  if (!context) {
    throw new Error('useCashBalance debe usarse dentro de <CashBalanceProvider>');
  }
  return context;
};
